import { BlackLayout } from 'root/src/client/v2/common/layouts/BlackLayout';
import { TitleBattlePass } from 'root/src/client/v2/battlePass/components/TitleBattlePass';
import { SkeletonBattlePassFilters, BattlePassTiersFilter, } from 'root/src/client/v2/_pages/battle-pass-details/components/BattlePassDetailsFilters';
import { useBattlePassDetails, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
import { useBattlePassDropMnemonicId, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { defaultDropFilter } from 'root/src/client/v2/_pages/battle-pass-details/constants';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
export const BattlePassFilters = () => {
    const battlePassDetails = useBattlePassDetails();
    if (battlePassDetails.isLoading) {
        return <SkeletonBattlePassFilters />;
    }
    return (<BlackLayout>
			{battlePassDetails.battlePass && (<BattlePassDetails description={battlePassDetails === null || battlePassDetails === void 0 ? void 0 : battlePassDetails.battlePass.description} image={addHttpsProtocol(battlePassDetails === null || battlePassDetails === void 0 ? void 0 : battlePassDetails.battlePass.image)}/>)}
			<BattlePassTiersFilter />
			<BattlePassDropsMultiSelect />
		</BlackLayout>);
};
const BattlePassDetails = ({ image, description }) => {
    return (<div className="flex flex-col lg:flex-row justify-center items-center">
			<div className="flex items-center justify-center max-w-[350px]">
				<div className="rounded-lg size-[150px] overflow-hidden border border-teal cursor-pointer">
					<img className="select-none w-full h-full hover:scale-125 hover:-rotate-12 transition duration-150" src={image} alt="battlePassImage"/>
				</div>
			</div>
			<TitleBattlePass className="mb-6 lg:mr-[350px]" description={description}/>
		</div>);
};
const BattlePassDropsMultiSelect = () => {
    const battlePassDetails = useBattlePassDetails();
    const { dropMnemonicIds, onDropMnemonicIds } = useBattlePassDropMnemonicId();
    return (<div className="mt-4 flex m-auto gap-4">
			<p className="text-teal text-lg font-mono">DROPS: </p>
			<div className="flex flex-wrap gap-3">
				{[defaultDropFilter, ...battlePassDetails.drops].map((drop) => {
            const isActive = dropMnemonicIds.includes(drop.mnemonicId);
            return (<DropsBadge key={drop.id} mnemonicId={drop.mnemonicId} label={drop.campaignName.toUpperCase()} isActive={isActive} onChange={onDropMnemonicIds}/>);
        })}
			</div>
		</div>);
};
export const DropsBadge = ({ isActive, onChange, label, mnemonicId }) => {
    return (<Badge data-active={isActive} onClick={() => onChange({ mnemonicId, isActive })} className="select-none cursor-pointer capitalize data-[active=true]:motion-safe:animate-slide-up motion-safe:duration-150 bg-primary brightness-50 data-[active=false]:hover:brightness-100 data-[active=true]:brightness-100">
			{label}
		</Badge>);
};
